import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { CookieNotice } from './components/CookieNotice';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
    {/* Рядом с App, а не внутри: плашка обязана быть видна и на экране входа,
        до того как появится профиль. Внутри Telegram она сама себя прячет. */}
    <CookieNotice />
  </React.StrictMode>,
);
